import { Link } from "react-router";
import { CONDITION_SHORT_NAMES } from "../../models/condition-short-names";
import { CONDITION_NAMES } from "../../models/conditions";

export function ConditionPill({
  code,
  severity,
  to,
  count,
}: {
  code: string;
  severity?: string;
  to: string;
  count?: number;
}) {
  const short = CONDITION_SHORT_NAMES[code] ?? code;
  const name = CONDITION_NAMES[code as keyof typeof CONDITION_NAMES] ?? code;
  return (
    <Link
      to={to}
      className={`pill${severity ? ` sev-${severity}` : ""}`}
      title={`${name} · ${code}`}
    >
      {short}
      {count !== undefined ? ` (${count})` : ""}
    </Link>
  );
}
